import { 
    apiBizInsertEContract,
    apiBizEContractDepositAndBillSetting,
    apiBizEContractNotify,
    apiBizGetAvailableHouse,
    apiBizGetContractPeriod
} from "@/apis/api.js"; 

const defaultContractData = {
    "tenantName" : null,
    "tenantPhone" : null,
    "tenantIdNumber" : null,
    "contractBeginTime" : null,
    "contractEndTime" : null,
    "tenantNumber" : null,
}
const defaultIdentification = {
    font: [],
    back: []
}
const defaultDatePeriod = {
    contractPeriod: [],
    billPeriod: []
}
const defaultSelectedHouseInfo = {
    seleted: null,
    houseCid: null,
    houseName: null,
    rent: 0,
    address: null,
    houseStatus: null,
    moveInDate: null,
    contractPeriod: [],
    agentName: null
}
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_contract_id: 'bizNewEContract/set_contract_id',
    set_nonbooking_contract: 'bizNewEContract/set_nonbooking_contract',
    set_contract_status: 'bizNewEContract/set_contract_status',
    set_notify_status: 'bizNewEContract/set_notify_status',
    set_signed_status: 'bizNewEContract/set_signed_status',
    set_contract_data: 'bizNewEContract/set_contract_data',
    set_id_card_img: 'bizNewEContract/set_id_card_img',
    set_date_period: 'bizNewEContract/set_date_period',
    set_selected_house: 'bizNewEContract/set_selected_house',
    set_default: 'bizNewEContract/set_default',
    set_available_house: 'bizNewEContract/set_available_house',
    set_contract_period: 'bizNewEContract/set_contract_period',

}

// count state 必須是 Object
const state = {
    contractId: null,
    contractStatus: 1,
    isSinged: false,
    nonbookingContract: {
        nonBookingContractCid: null,
        contractDeposit: 0,
        contractBeginTime: null
    },
    contractData: Object.assign({}, defaultContractData),
    identification: Object.assign({}, defaultIdentification),
    datePeriod: Object.assign({}, defaultDatePeriod),
    selectedHouseInfo: Object.assign({}, defaultSelectedHouseInfo),
    availableHouseList: [],
    contractPeriod: []
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_ECONTRACT_ID: (state) => {
        return state.contractId
    },
    GET_BIZ_NONBOOKING_CONTRACT: (state) => {
        return state.nonbookingContract
    },
    GET_BIZ_ECONTRACT_STATUS: (state) => {
        return state.contractStatus
    },
    GET_BIZ_SIGNED_STATUS: (state) => {
        return state.isSinged
    },
    GET_BIZ_ECONTRACT_DATA: (state) => {
        return state.contractData
    },
    GET_BIZ_ECONTRACT_IDENTIFICATION: (state) => {
        return state.identification
    },
    GET_BIZ_ECONTRACT_DATE_PERIOD: (state) => {
        return state.datePeriod
    },
    GET_BIZ_ECONTRACT_SELECTED_HOUSE: (state) => {
        return state.selectedHouseInfo
    },
    GET_BIZ_ECONTRACT_AVAILABLE_HOUSE: (state) => {
        return state.availableHouseList
    },
    GET_BIZ_ECONTRACT_PERIOD: (state) => {
        return state.contractPeriod
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizGetAvailableHouse ( {commit} ) {
        return new Promise((resolve, reject) => {
            apiBizGetAvailableHouse()
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    console.log('apiBizGetAvailableHouse',res.data.result)
                    commit(types.set_available_house, res.data.result)
                }
                resolve()
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    getBizGetEContractPeriod ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetContractPeriod(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_contract_period, res.data.result);
                    resolve(true)
                }else{
                    resolve(false)
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setBizNewEContractId ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_id, data);
            resolve()
        })
    },
    saveBizNewEContract ( {commit, dispatch, state} , data) {
        return new Promise((resolve, reject) => {
            apiBizInsertEContract(data)
            .then(res => {
                console.log('儲存合約基本資料')
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_nonbooking_contract, res.data.result)
                    resolve(true)
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    resolve(false)
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    saveBizNewEContractBill ( {commit, dispatch, state} , data) {
        return new Promise((resolve, reject) => {
            apiBizEContractDepositAndBillSetting(data)
            .then(res => {
                console.log('儲存合約基本資料')
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_contract_id, res.data.result.contractCid)
                    resolve(true)
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    resolve(false)
                }
                resolve()
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    bizECNotifyTanant ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            
            apiBizEContractNotify(data)
            .then(res => {
                console.log('打通知租客ＡＰＩ')
                if( res.data.status == "SUCCESS" ){
                    resolve(true)
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    resolve(false)
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    bizSetNewEContractStatus ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_status, data)
        })
    },
    bizSetNewEContractSingedStatus ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_signed_status, data)
        })
    },
    bizSetNewEContractData ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_data, data)
        })
    },
    bizSetNewEContractIOdentification ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_id_card_img, data)
        })
    },
    bizSetNewEContractDatePeriod ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_date_period, data)
        })
    },
    bizSetNewEContractSelectedHouse ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_selected_house, data)
        })
    },
    bizSetNewEContractDefault ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_default)
        })
    }
}

// mutations
const mutations = {
    [types.set_contract_id](state, data){
        state.contractId = data
    },
    [types.set_nonbooking_contract](state, data){
        state.nonbookingContract = data
    },
    [types.set_contract_period](state, data){
        state.contractPeriod = data
    },
    [types.set_contract_status](state, data){
        state.contractStatus = data
    },
    [types.set_notify_status](state, data){
        state.notifyStatus = data
    },
    [types.set_signed_status](state, data){
        state.isSinged = data
    },
    [types.set_contract_data](state, data){
        state.contractData = data
    },
    [types.set_id_card_img](state, data){
        state.identification = data
    },
    [types.set_date_period](state, data){
        state.datePeriod = data
    },
    [types.set_selected_house](state, data){
        state.selectedHouseInfo = data
    },
    [types.set_available_house](state, data){
        state.availableHouseList = data
    },
    [types.set_default](state, data){
        state.contractStatus = 1
        state.isSinged = false
        state.contractData = Object.assign({}, defaultContractData)
        state.identification = Object.assign({}, defaultIdentification)
        state.datePeriod = Object.assign({}, defaultDatePeriod)
        state.selectedHouseInfo = Object.assign({}, defaultSelectedHouseInfo)
    },
    
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/leaseMgt/newEContract.js